import { GetProjectById, GetProjectByIdToken } from "$src/application/projects/queries/GetProjectById";
import { Project } from "$src/domain/projects/Project";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

export async function fetchProject(groupStoreId: number, projectId: number): Promise<Project> {
    const query = container.resolve<GetProjectById>(GetProjectByIdToken);
    return query.execute(groupStoreId, projectId);
}

export function useProject(groupStoreId: number, projectId: number) {

    return useQuery<Project, Error>({
        queryKey: ['project', groupStoreId, projectId],
        queryFn: () => fetchProject(groupStoreId, projectId),
        staleTime: 30000,
        cacheTime: 60000,
    });
}
